import Landing from "../components/Landing";
import Triple from "../components/Triple";
import Contact from "../components/Contact";

function Home() {
  return (
    <div>
      <Landing />
      <Triple />
      <Contact />
    </div>
  );
}

export default Home;
